const initialState = () => ({
  current: null,
  tasksForm: null,
  tasksEditing: null,
  uncompletedTasks: false,
  loading: false,
  printing: false,
  uploadingItems: [],
  uploadingPhotos: [],
  signatureroles: [],
  unansweredItems: [],
  groupsWithUnansweredItems: new Set(),
  logicFag: null
})

export default initialState
